import { skipToken, useQuery } from "@tanstack/react-query";

import DocsService from "@/api/services/docs";

export function useCreateDestinationDocs(vendor: string | undefined) {
  return useQuery({
    queryKey: ["docs", "destination", vendor],
    queryFn: vendor ? () => DocsService.getCreateDestinationDocs({ vendor: vendor! }) : skipToken,
  });
}
